import { ReactNode } from 'react';
import {
  BenefitInfoTextExtensionInterface,
  BenefitInfoTextProps,
  BenefitLinkProps,
  BenefitSpecialLinkProps,
} from '../../../../extension/interface/benefit-info-text.extension.interface';
import { NonCashBenefitInfoText } from '../../../../page/benefit/NonCashBenefitInfoText';

export class CouponsBenefitInfoTextExtension extends BenefitInfoTextExtensionInterface {
  getBenefitLinks(): BenefitLinkProps | undefined {
    return {
      managerSpecific: 'https://www.youtube.com/watch?v=lgy1tLA4E5I',
      appSpecific: 'https://www.youtube.com/watch?v=NlmdzWIfwng',
    };
  }

  getBenefitMoreLinks(): BenefitSpecialLinkProps | undefined {
    return undefined;
  }

  getHelpCenterLink(): string | undefined {
    return 'https://support.probonio.de/hc/de/sections/21154612044434--Sachbezug';
  }

  renderAdditionalContent(_props: BenefitInfoTextProps): ReactNode {
    return <NonCashBenefitInfoText />;
  }
}
